export default {
  getFormModules: state => state.attendanceFormModules,
  getCanEdit: state => state.canEdit,
  fetchAttendanceData: state => state.attendance,
  getLoading: state => state.loading,
  getSelectedForm: state => state.selectedForm,
  getPreConsultation: state => state.preConsultation,
  getDocs: state => state.docs,
  getExams: state => state.exams,
  getForm: state => state.form,
  getCustomFormEdit: state => state.customFormEdit,
  bvConsultation: state => state.bvConsultation,
  certificate: state => state.certificate,
  getIsOculosImporting: state => state.isOculosImporting
}
